<script setup>
import { DxDropDownButton } from 'devextreme-vue/drop-down-button';

const props = defineProps({
  editor: Object,
});

const types = [
  {
    value: '1',
    text: 'Tal',
  },
  {
    value: 'A',
    text: 'Store bogstaver',
  },
  {
    value: 'a',
    text: 'Små bogstaver',
  },
  {
    value: 'I',
    text: 'Store romertal',
  },
  {
    value: 'i',
    text: 'Små romertal',
  },
  {
    value: 'delete',
    text: 'Fjern liste',
  },
];

function onSelectType(e) {
  const { value } = e.itemData;
  if (value === 'delete') {
    props.editor.chain().toggleOrderedList().run();
  } else {
    setStyle(value);
  }
}

function setStyle(type) {
  let commands = props.editor.chain().focus();
  if (!props.editor.isActive('orderedList')) {
    commands.focus().toggleOrderedList();
  }
  commands.updateAttributes('orderedList', { type: type }).run();
}
</script>

<template>
  <DxDropDownButton
    :items="types"
    :dropDownOptions="{ width: 200 }"
    icon="orderedlist"
    displayExpr="text"
    keyExpr="value"
    @item-click="onSelectType"
    :elementAttr="{ title: 'Nummereret liste' }"
  >
  </DxDropDownButton>
</template>

<style scoped lang="scss"></style>
